import { render, staticRenderFns } from "./HospitalsGroupsUsers.vue?vue&type=template&id=5f8a7a43&"
import script from "./HospitalsGroupsUsers.vue?vue&type=script&lang=js&"
export * from "./HospitalsGroupsUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8a7a43')) {
      api.createRecord('5f8a7a43', component.options)
    } else {
      api.reload('5f8a7a43', component.options)
    }
    module.hot.accept("./HospitalsGroupsUsers.vue?vue&type=template&id=5f8a7a43&", function () {
      api.rerender('5f8a7a43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DashboardFilters/HospitalsGroupsUsers.vue"
export default component.exports